import { AxiosInstance } from "axios";
import CommonDomainService from "../api/CommonDomain.service";
import TradeService from "../api/Trade.service";
import DocumentService from "../api/Document.service";
import UserService from "../api/User.service";
import ViaCepService from "../api/ViaCep.service";
import ProfileService from "../api/Profile.service";
import RuleService from "../api/Rule.service";
import ScreenService from "../api/Screen.service";
import ResourceService from "../api/Resource.service";
import { UserAuthService } from "../api/UserAuth.service";
import TradeApprovalPhaseLogService from "../api/TradeApprovalPhaseLog.service";
import TradePhaseService from "../api/TradePhase.service";
import CredDefenseService from "../api/CredDefense.service";
import FraudService from "../api/Fraud.service";
import { BCheckService } from "../api/BCheck.service";
import PendencyService from "../api/Pendency.service";
import FileService from "../api/File.service";
import PricingBatchService from "../api/PricingBatch.service";
import EmailApprovalService from "../api/email/EmailApproval.service";
import TradeSearchService from "../api/TradeSearch.service";
import TradeAnalysisService from "../api/TradeAnalysis.service";
import { BCheckBatchService } from "../api/BCheckBatch.service";
import EntubaCedenteCotaService from '../api/EntubaCedenteCota.service';
import LogService from '../api/Log.service';
import TradeContingencyService from "../api/TradeContingency.service";
import BoilerplateEmailService from "../api/email/BoilerplateEmail.service";
import MountedEmailService from "../api/email/MountedEmail.service";
import TemplateEmailService from "../api/email/TemplateEmail.service";
import AdministratorService from "../api/Administrator.service";
import AuthRuleService from "../api/AuthRule.service";
import AuthProfileService from "../api/AuthProfile.service";
import TransferApprovalService from "../api/EntubaTransferApproval.service";
import ClickSignService from "../api/ClickSign.service";
import EntubaCotaPriceService from "../api/EntubaCotaPrice.service";
import EntubaUpdateCedenteService from "../api/EntubaUpdateCedente.service";
import PayslipService from '../api/Payslip.service';
import BureauSelfieService from '../api/BureauSelfie.service';
import DashboardReportService from '../api/DashboardReport.service';
import DisbursementService from "../api/Disbursement.service";
import AssigneeService from "../api/Assignee.service";
import AdministratorApprovalService from '../api/AdministratorApproval.service';
import { BCheckRetryService } from '../api/BCheckRetry.service';
import ReportService from '../api/ReportService.service';
import TradeRollbackPhase from "../api/TradeRollbackPhase.service";
import Contigency from "../api/Contigency.service"
import TradeWalletSearchService from '../api/TradeWalletSearch.service';
import QuotaService from "../api/Cota.service";
import TradeDisbursementService from "../api/TradeDisbursement.service";
import CustomWorkflowService from '../api/CustomWorkflow.service';
import ContractDocumentBatchService from "../api/ContractDocumentBatch.service";
import ContractDocumentService from "../api/ContractDocument.service";
import SendAdministratorRequestService from "../api/SendAdministratorRequest.service";
import PanReportService from "../api/PanReport.service";
import EntubaUpdateCotaLoteService from "../api/EntubaUpdateCotaLote.service";
import EntubaReceivableService from "../api/EntubaReceivables.service";
import OCRParserService from "../api/OCRParser.service";
import EntubaCotaDeactivationService from "../api/EntubaCotaDeactivation.service";
import CalculadoraCarregoService from "../api/CalculadoraCarrego.service";
import EntubaCotaParcelaService from "../api/EntubaCotaParcela.service";
import TraderConsulterService from "../api/TraderConsulter.service";
import BusinessPartnerReportService from "../api/BusinessPartner/report.service";
import BusinessPartnerReportPublicService from "../api/BusinessPartner/partnerReport.service";
import TradeDocumetService from "../api/TradeDocumet.service";
import BPEntubaLeadsService from "../api/BusinessPartner/entuba/leads/entuba-leads.service";
import BPEntubaFormalizationService from "../api/BusinessPartner/entuba/formalization/entuba-formalization.service";
import ReportIndicatorsService from "../api/ReportIndicators.service";
import { FraudsysRetryService } from "../api/FraudsysRetry.service";
import PdfModelService from "../api/PdfModel.service";
import CotaConsorcieiService from "../api/CotaConsorciei.service";
import EntubaUpdateExpenseService from "../api/EntubaUpdateExpense.service";
import EntubaOCRService from "../api/EntubaOCR.service";
import TradePricingPendingApprovalService from "../api/Pricing/trade-pricing-pending/TradePricingPedingApproval.service";
import LeadsDatasetPricingPendingService from "../api/Pricing/leads-dataset-pricing-pending/LeadsDatasetPricingPending.service";
import SpreadService from "../api/Spread.service";
import EntubaCotaCessionarioService from "../api/EntubaCotaCessionario.service";
import CompanyNegociationService from "../api/CompanyNegociation.service";
import StrategyService from "../api/Strategy.service";
import ExtractDocumentBatchService from "../api/ExtractDocumentBatch.service";
import PremiseService from "../api/Premise.service";
import PricingBidReportService from "../api/PricingBidReport.service";
import PriceService from "../api/Price.service";
import EntubaRepasseTradeService from "../api/EntubaRepasseTrade.service";
import TokerizacaoTradeService from "../api/TokerizacaoTrade.service";
export default class ServiceApi {
  public restClient: AxiosInstance;
  public restClientOut: AxiosInstance;
  public viaCepService: ViaCepService;
  public bCheckService: BCheckService;
  public commonDomainService: CommonDomainService;
  public tradeService: TradeService;
  public tradeAnalysisService: TradeAnalysisService;
  public documentService: DocumentService;
  public userService: UserService;
  public profileService: ProfileService;
  public ruleService: RuleService;
  public screenService: ScreenService;
  public resourceService: ResourceService;
  public userAuthService: UserAuthService;
  public fileService: FileService;
  public tradeApprovalPhaseLogService: TradeApprovalPhaseLogService;
  public tradePhaseService: TradePhaseService;
  public credDefenseService: CredDefenseService;
  public fraudService: FraudService;
  public pendencyService: PendencyService;
  public pricingBatchService: PricingBatchService;
  public bcheckBatchService: BCheckBatchService;
  public tradeSearchService: TradeSearchService;
  public entubaBCheckService: EntubaCedenteCotaService;
  public logService: LogService;
  public tradeContingencyService: TradeContingencyService;
  public emailService: EmailApprovalService;
  public boilerplateEmailService: BoilerplateEmailService;
  public mountedEmailService: MountedEmailService;
  public templateEmailService: TemplateEmailService;
  public administratorService: AdministratorService;
  public calculadoraCarregoService: CalculadoraCarregoService;
  public authRuleService: AuthRuleService;
  public authProfileService: AuthProfileService;
  public transferApprovalService: TransferApprovalService;
  public entubaCotaParcelaService: EntubaCotaParcelaService;
  public clickSignService: ClickSignService;
  public entubaCotaPriceService: EntubaCotaPriceService;
  public entubaUpdateCedenteService: EntubaUpdateCedenteService;
  public entubaCotaCessionarioService: EntubaCotaCessionarioService;
  public entubaRepasseTradeService: EntubaRepasseTradeService;
  public tokerizacaoTradeService: TokerizacaoTradeService;
  public payslipService: PayslipService;
  public bureauSelfieService: BureauSelfieService;
  public dashboardReportService: DashboardReportService;
  public disbursementService: DisbursementService;
  public assigneeService: AssigneeService;
  public companyNegociationService: CompanyNegociationService;
  public administratorApprovalService: AdministratorApprovalService;
  public bcheckRetryService: BCheckRetryService;
  public fraudsysRetryService: FraudsysRetryService;
  public reportService: ReportService;
  public tradeRollbackPhase: TradeRollbackPhase;
  public contigency: Contigency;
  public tradeWalletSearchService: TradeWalletSearchService;
  public sendAdministratorRequestService: SendAdministratorRequestService;
  public quotaService: QuotaService;
  public tradeDisbursementService: TradeDisbursementService;
  public customWorkflowService: CustomWorkflowService;
  public contractDocumentBatchService: ContractDocumentBatchService;
  public contractDocumentService: ContractDocumentService;
  public panReportService: PanReportService;
  public entubaUpdateCotaLoteService: EntubaUpdateCotaLoteService;
  public entubaReceivableService: EntubaReceivableService;
  public ocrParserService: OCRParserService;
  public pdfModelService: PdfModelService;
  public cotaConsorcieiService: CotaConsorcieiService;

  public entubaCotaDeactivation: EntubaCotaDeactivationService;

  public traderConsulterService: TraderConsulterService;

  public bpReport: BusinessPartnerReportService;
  public bpPartnerReport: BusinessPartnerReportPublicService;

  public tradeDocumentService: TradeDocumetService;

  public bpEntubaFormalizationService: BPEntubaFormalizationService;
  public bpEntubaLeadsService: BPEntubaLeadsService;

  public reportIndicatorsService: ReportIndicatorsService;

  public entubaUpdateExpenseService: EntubaUpdateExpenseService;
  public entubaOCRService: EntubaOCRService;

  public tradePricingPendingApprovalService: TradePricingPendingApprovalService;

  public leadsDatasetPricingPendingService: LeadsDatasetPricingPendingService;

  public spreadService: SpreadService;
  public strategyService: StrategyService;
  public extractBatch: ExtractDocumentBatchService;
  public premiseService: PremiseService;

  public pricingBidReport: PricingBidReportService;

  public priceService: PriceService;

  constructor(restClient: AxiosInstance, restClientOut: AxiosInstance) {
    this.restClient = restClient;
    this.restClientOut = restClientOut;
    this.viaCepService = new ViaCepService();

    this.ruleService = new RuleService(this.restClientOut);
    this.userAuthService = new UserAuthService(this.restClientOut);
    this.commonDomainService = new CommonDomainService(this.restClientOut);
    this.administratorApprovalService = new AdministratorApprovalService(this.restClientOut);
    this.clickSignService = new ClickSignService(this.restClientOut);
    this.tradePhaseService = new TradePhaseService(this.restClientOut);
    this.tradeSearchService = new TradeSearchService(this.restClientOut);
    this.tradeApprovalPhaseLogService = new TradeApprovalPhaseLogService(this.restClientOut);
    this.entubaBCheckService = new EntubaCedenteCotaService(this.restClientOut);
    this.entubaCotaPriceService = new EntubaCotaPriceService(this.restClientOut);
    this.entubaUpdateCedenteService = new EntubaUpdateCedenteService(this.restClientOut);
    this.administratorService = new AdministratorService(this.restClientOut);
    this.calculadoraCarregoService = new CalculadoraCarregoService(this.restClientOut);
    this.authRuleService = new AuthRuleService(this.restClientOut);
    this.authProfileService = new AuthProfileService(this.restClientOut);
    this.customWorkflowService = new CustomWorkflowService(this.restClientOut);
    this.contractDocumentBatchService = new ContractDocumentBatchService(this.restClientOut);
    this.contractDocumentService = new ContractDocumentService(this.restClientOut);
    this.panReportService = new PanReportService(this.restClientOut);
    this.entubaUpdateCotaLoteService = new EntubaUpdateCotaLoteService(this.restClientOut);
    this.entubaReceivableService = new EntubaReceivableService(this.restClientOut);
    this.entubaCotaDeactivation = new EntubaCotaDeactivationService(this.restClientOut);
    this.traderConsulterService = new TraderConsulterService(this.restClientOut);

    this.fileService = new FileService(this.restClientOut);
    this.tradeDisbursementService = new TradeDisbursementService(this.restClientOut);
    this.bCheckService = new BCheckService(this.restClientOut);
    this.tradeAnalysisService = new TradeAnalysisService(this.restClientOut);
    this.credDefenseService = new CredDefenseService(this.restClientOut);
    this.fraudService = new FraudService(this.restClientOut);
    this.tradeDocumentService = new TradeDocumetService(this.restClientOut);
    this.bureauSelfieService = new BureauSelfieService(this.restClientOut);
    this.tradeRollbackPhase = new TradeRollbackPhase(this.restClientOut);
    this.contigency = new Contigency(this.restClientOut);

    this.bpEntubaFormalizationService = new BPEntubaFormalizationService(this.restClientOut);
    this.bpEntubaLeadsService = new BPEntubaLeadsService(this.restClientOut);

    this.bpReport = new BusinessPartnerReportService(this.restClient);
    this.bpPartnerReport = new BusinessPartnerReportPublicService(this.restClientOut);
    this.dashboardReportService = new DashboardReportService(this.restClient);
    this.transferApprovalService = new TransferApprovalService(this.restClient);
    this.entubaCotaParcelaService = new EntubaCotaParcelaService(this.restClient);
    this.profileService = new ProfileService(this.restClient);
    this.userService = new UserService(this.restClient);
    this.tradeService = new TradeService(this.restClient);
    this.documentService = new DocumentService(this.restClient);
    this.screenService = new ScreenService(this.restClient);
    this.resourceService = new ResourceService(this.restClient);
    this.tradeContingencyService = new TradeContingencyService(this.restClient);
    this.pendencyService = new PendencyService(this.restClient);
    this.pricingBatchService = new PricingBatchService(this.restClient);
    this.bcheckBatchService = new BCheckBatchService(this.restClient);
    this.logService = new LogService(this.restClient);
    this.emailService = new EmailApprovalService(this.restClient);
    this.boilerplateEmailService = new BoilerplateEmailService(this.restClient);
    this.templateEmailService = new TemplateEmailService(this.restClient);
    this.mountedEmailService = new MountedEmailService(this.restClient);
    this.payslipService = new PayslipService(this.restClient);
    this.disbursementService = new DisbursementService(this.restClient);
    this.bcheckRetryService = new BCheckRetryService(this.restClient);
    this.fraudsysRetryService = new FraudsysRetryService(this.restClient);
    this.reportService = new ReportService(this.restClient);
    this.tradeWalletSearchService = new TradeWalletSearchService(this.restClient);
    this.sendAdministratorRequestService = new SendAdministratorRequestService(this.restClient);
    this.quotaService = new QuotaService(this.restClient);
    this.assigneeService = new AssigneeService(this.restClient);
    this.ocrParserService = new OCRParserService(this.restClient);
    this.pdfModelService = new PdfModelService(this.restClient);
    this.reportIndicatorsService = new ReportIndicatorsService(this.restClient);
    this.cotaConsorcieiService = new CotaConsorcieiService(this.restClientOut);
    this.entubaUpdateExpenseService = new EntubaUpdateExpenseService(this.restClientOut);
    this.entubaOCRService = new EntubaOCRService(this.restClientOut);
    this.entubaCotaCessionarioService = new EntubaCotaCessionarioService(this.restClient);

    this.tradePricingPendingApprovalService = new TradePricingPendingApprovalService(this.restClientOut);
    this.leadsDatasetPricingPendingService = new LeadsDatasetPricingPendingService(this.restClientOut);
    this.spreadService = new SpreadService(this.restClientOut);

    this.companyNegociationService = new CompanyNegociationService(this.restClient);
    this.strategyService = new StrategyService(this.restClient);
    this.extractBatch = new ExtractDocumentBatchService(this.restClient);
    this.pricingBidReport = new PricingBidReportService(this.restClient);
    this.premiseService = new PremiseService(this.restClientOut);

    this.priceService = new PriceService(restClientOut);
    // -----------------------------------Entuba de repasse ------------------------------------------------
    this.entubaRepasseTradeService = new EntubaRepasseTradeService(this.restClient);
    this.tokerizacaoTradeService = new TokerizacaoTradeService(this.restClient);
  }
}



// WEBPACK FOOTER //
// ./src/services/model/ServiceApi.model.ts